module.exports = __webpack_public_path__ + "img/ic_jishuzhichi.f9cbe292.svg";